import gql from 'graphql-tag';

export default gql(`
	query filters( $language_code: String )  {
		filters( language_code: $language_code ) {
			filters
		}
	}
`);